import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';

export class ExecuteOnActualDataHelper extends WorkflowModuleSettingsHelper {
    getEntryPoints(): WorkflowExitInfo[] {
        const data = new WorkflowExitInfo();
        data.Type = 'relData'
        return [data];
    }

    getExitPoints(settings: any): WorkflowExitInfo[] {
        const data = new WorkflowExitInfo();
        data.ID = 0;
        data.Label = '@@Data';
        data.Type = 'relDataEntry';
        const exit = new WorkflowExitInfo();
        exit.ID = 1;
        exit.Label = '@@Ende';
        exit.Type = 'relData';
        return [data, exit];
    }

    getEmptySettingsInstance() {
        return new ExecuteOnActualDataSettingsData();
    }
}

export class ExecuteOnActualDataSettingsData {
    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'execOnDataWFModule';
        reg.Caption = '@@Auf Datenzeile ausfuehren';
        reg.GroupID = 'reldataoperations';
        reg.Index = 60;
        reg.SettingsTypeHelper = new ExecuteOnActualDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }
}

export class ExecuteOnActualObjectHelper extends WorkflowModuleSettingsHelper {
    getEntryPoints(): WorkflowExitInfo[] {
        const data = new WorkflowExitInfo();
        data.Type = 'objData'
        return [data];
    }

    getExitPoints(settings: any): WorkflowExitInfo[] {
        const data = new WorkflowExitInfo();
        data.ID = 0;
        data.Label = '@@Object';
        data.Type = 'objDataEntry';
        const exit = new WorkflowExitInfo();
        exit.ID = 1;
        exit.Label = '@@Ende';
        exit.Type = 'objData';
        return [data, exit];
    }

    getEmptySettingsInstance() {
        return new ExecuteOnActualObjectSettingsData();
    }
}

export class ExecuteOnActualObjectSettingsData {
    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'execOnObjectWFModule';
        reg.Caption = '@@Auf Objekt ausfuehren';
        reg.GroupID = 'objectoperations';
        reg.Index = 25;
        reg.SettingsTypeHelper = new ExecuteOnActualObjectHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }
}
